export const getLeafNodes = (conditions = {}) => {
  const { _qualified, ...restConditions } = conditions;
  const [clauseType] = Object.keys(restConditions);
  if (['and', 'or', 'not'].includes(clauseType)) {
    return conditions[clauseType].flatMap(getLeafNodes);
  }
  return conditions;
};

export const evaluate = (url, conditions) => {
  const [firstKey] = Object.keys(conditions);

  if (['and', 'or', 'not'].includes(firstKey)) {
    if (firstKey === 'and') {
      return conditions[firstKey].every(condition => {
        return evaluate(url, condition);
      });
    }
    if (firstKey === 'or') {
      return conditions[firstKey].some(condition => {
        return evaluate(url, condition);
      });
    }
    if (firstKey === 'not') {
      return !conditions[firstKey].some(condition => {
        return evaluate(url, condition);
      });
    }
  }

  const { hostname: domain, pathname, search, hash } = new URL(url);
  const urlPath = `${pathname}${search ? `?${search}` : ''}${
    hash ? `#${hash}` : ''
  }`;

  const opertateOn = conditions.url ? urlPath : domain;
  const { operator, value } = conditions.url || conditions.domains;

  switch (operator) {
    case '^':
      return opertateOn.startsWith(value);
    case '!^':
      return !opertateOn.startsWith(value);
    case '$':
      return opertateOn.endsWith(value);
    case '!$':
      return !opertateOn.endsWith(value);
    case '*':
      return opertateOn.includes(value);
    case '!*':
      return !opertateOn.includes(value);
    case '!=':
      return opertateOn !== value;
    case 'regex':
      return new RegExp(value).test(opertateOn);
    case '==':
    default:
      return opertateOn === value;
  }
};
